export default __webpack_public_path__ + "static/map.url-e5398ec06667b55d53f9fe52b7f7c461.svg";